import { Link, Navigate } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHead, Section, CtaBand, QaBlock } from "@/components/Shared";
import { ClinicSidebar } from "@/components/ClinicSidebar";
import { UI, PATHS } from "@/i18n/ui";
import { ORG_JSONLD } from "@/data/site";
import { findArea } from "@/data/areas";
import { SERVICES } from "@/data/services";

export default function AreaPage({ lang, areaKey }) {
  const t = UI[lang];
  const p = PATHS[lang];
  const area = findArea(areaKey);
  if (!area) return <Navigate to={p.home} replace />;
  return (
    <div data-testid={`area-page-${area.key}`}>
      <Seo title={area.meta[lang].title} description={area.meta[lang].desc} lang={lang} jsonLd={[ORG_JSONLD]} />
      <PageHead eyebrow={t.nav.location} title={area.h1[lang]} sub={area.intro[lang]} />
      <Section className="pt-0">
        <div className="grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            {area.body[lang].map(([h, txt]) => <QaBlock key={h} q={h}><p>{txt}</p></QaBlock>)}
            <h2 className="mt-10 mb-5 text-2xl font-display text-[#1F2937]">
              {lang === "id" ? "Layanan yang tersedia" : "Available services"}
            </h2>
            <div className="flex flex-wrap gap-3">
              {SERVICES.map((s) => (
                <Link key={s.key} to={p.service(s.slug[lang])} data-testid={`area-service-${s.key}`}
                  className="rounded-full bg-white border border-[#E5E1D8] px-5 py-2.5 text-sm font-medium text-[#1F2937] hover:border-[#4A6B53] hover:text-[#4A6B53] transition-colors">
                  {s.name[lang]}
                </Link>
              ))}
            </div>
          </div>
          <aside>
            <ClinicSidebar lang={lang} prefix="area"
              waText={lang === "id"
                ? "Halo Bali Empower, saya dari area " + area.label.id
                : "Hello Bali Empower, I am contacting you from the " + area.key + " area"} />
          </aside>
        </div>
      </Section>
      <CtaBand lang={lang} />
    </div>
  );
}
